<template>
  <el-container style="width: 100%; height: 100%;">
    <Sidebar></Sidebar>
    <el-container style="flex-basis: 0%">
      <el-header>
        <Navbar></Navbar>
      </el-header>
      <router-view></router-view>
    </el-container>
  </el-container>
</template>


<script>
// import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
import { Navbar, Sidebar } from "./components";
export default {
  name: "layout",
  components: {
    Navbar,
    Sidebar,
  },
  data() {
    return {
      isCollapse: true,
    };
  },

  methods: {
    clickCollapseMenu() {
      this.isCollapse = !this.isCollapse;
    },
  },
};
</script>



<style scoped>
.el-header {
  height: auto !important;
  background-color: white;
  padding: 0;
}

.el-main {
  padding: 5px 20px;
}
</style>
   <!-- 左侧菜单样式 -->
<style>
.nav-link {
  color: turquoise;
}

.navbar {
  height: 50px;
  padding: 0 30px 0 0;
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.flex-fill {
  flex: 1;
}

.navbar-menu {
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.navbar-menu-item {
  width: auto;
  min-width: 40px;
  line-height: 50px;
  padding: 0 5px;
  height: 100%;
  display: flex;
  justify-content: center;
}

.el-submenu__title {
  text-align: left;
}

.navbar-menu-item:hover {
  color: cornflowerblue;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>